import { AsyncPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CookiesAgreementComponentModule } from '@main/cookies-agreement/ui';
import { FooterNavigationModule, PagesNavigationModule } from '@main/navigation/ui';
import { MainOnlineChatsUiModule } from '@main/online-chats/ui';
import { MainSnackbarUiModule } from '@main/snackbar/ui';
import { HeaderCitySelectModule } from '@sdvor/city/ui';
import { ComparisonModule } from '@sdvor/comparison/ui';
import { CategoriesMenuModule, CustomHamburgerMenuModule } from '@sdvor/main/categories-menu/ui';
import { MobileMenuModule } from '@sdvor/main/mobile-menu/ui';
import { PhoneComponentModule } from '@sdvor/main/phone/ui';
import { SdvorCustomSearchBoxModule } from '@sdvor/search/ui';
import {
  LogoComponent,
  OutsideViewportDirective,
  ProcessLinkModule,
  SafeUrlPipe,
  SdvorGenericLinkComponent,
  SdvorLinkComponent,
  SdvorSocialLinksComponent,
} from '@sdvor/shared/ui';
import { LoginButtonModule, SwitchProfileModule } from '@sdvor/user/ui';
import { WishlistButtonModule } from '@sdvor/wishlist/ui';
import {
  LaunchDialogModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
  SpartacusBaseStorefrontModule,
} from '@spartacus/storefront';
import { SmartBannerComponentModule } from '../smart-banner';
import { TabBarModule } from '../tab-bar';
import { StorefrontComponent } from './storefront.component';

@NgModule({
  declarations: [StorefrontComponent],
  imports: [
    AsyncPipe,
    DatePipe,
    RouterOutlet,
    OutletModule,
    SafeUrlPipe,
    OutletRefModule,
    PageLayoutModule,
    MainSnackbarUiModule,
    LogoComponent,
    PageSlotModule,
    MainOnlineChatsUiModule,
    SpartacusBaseStorefrontModule,
    LaunchDialogModule.forRoot(),
    SmartBannerComponentModule,
    HeaderCitySelectModule,
    SdvorGenericLinkComponent,
    SwitchProfileModule,
    CategoriesMenuModule,
    SdvorCustomSearchBoxModule,
    PhoneComponentModule,
    PagesNavigationModule,
    TabBarModule,
    MobileMenuModule,
    ComparisonModule,
    WishlistButtonModule,
    LoginButtonModule,
    FooterNavigationModule,
    ProcessLinkModule,
    SdvorSocialLinksComponent,
    SdvorLinkComponent,
    CookiesAgreementComponentModule,
    CustomHamburgerMenuModule,
    OutsideViewportDirective,
  ],
  exports: [StorefrontComponent],
})
export class StorefrontComponentModule {}
